"use client"

import { FilePen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FilePenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FilePenIcon = component(Icon)({ as: FilePen })
